<ion-toolbar color="danger" *ngIf="errorMessage" class="error-banner">
  <ion-buttons slot="start" style="margin-right: 8px;">
    <ion-icon name="warning-outline" size="large"></ion-icon>
  </ion-buttons>
  <ng-container [ngSwitch]="errorCode">
    <!-- RECONNECT_TARGET-->
    <ion-text *ngSwitchCase="'RECONNECT_TARGET'">
      <span>Problem with a publish target and needs to be reconnected.</span>
      <span>
      &nbsp;<a [routerLink]="['/settings/connect']" style="color: white; text-decoration: underline; cursor: pointer;">
        Fix in connection settings
      </a>
      </span>
    </ion-text>
    <ion-text *ngSwitchDefault>
      <span>{{ formattedErrorMessage }}</span>
      <span>&nbsp;<a (click)="createSupportTicket()" style="color: white; text-decoration: underline; cursor: pointer;">Click here to create a support ticket.</a></span>
    </ion-text>
  </ng-container>
  <ion-buttons slot="end">
    <ion-button fill="clear" color="light" (click)="dismissError()">
      <ion-icon name="close-circle"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
